import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { requestModal } from '../../stores/mainSlice';


import * as MediaSelector from '../../components/media/MediaSelector';
import i18n from 'i18n-js';

import { ContactPatternAside } from '../components/pattern/ContactPatternAside';
import { ContactPatternPrime } from '../components/pattern/ContactPatternPrime';

import { ModalMaster } from '../components/modals/ModalWrapper/ModalMaster';

export default function ContactScreen({ route }) {
  let pattern_value = {};

  const entry_id = route.params.k ?? null;

  switch (route.name) {
    case 'ViewContact': {
      pattern_value = { ...resolve_contact_screen({ id: entry_id }) };
      break;
    }
    case 'ViewChannel': {
      pattern_value = { ...resolve_channel_screen({ id: entry_id }) };
      break;
    }
  }

  return (
    <View className="flex-1" >
      <HStack className="flex-1" >

        {/* aside */}
        <VStack className="bg-secondary-50 h-[100%] w-[306px] border-[#d8d8d8] border">
          {pattern_value?.template_aside && <ContactPatternAside {...pattern_value.template_aside} />}
        </VStack>

        {/* main */}
        <VStack className="h-[100%] flex-1 pt-9 px-10 pb-9 items-center overflow-y-scroll overflow-x-clip">
          <VStack space='2xl' className="flex-none max-w-[100%] w-[1180px]">
            {pattern_value?.template_prime && <ContactPatternPrime {...pattern_value?.template_prime} />}
          </VStack>
        </VStack>

      </HStack>
      <ModalMaster />
    </View>
  );
}

const resolve_channel_screen = ({ id }) => {
  const dispatch = useDispatch();

  const entry_id = id;
  const entry = useSelector((state) => state.contacts.channels)
    .filter((state) => entry_id == state.id)
    .map((state) => ({
      channel: {
        id: state.id,
        name: state.name?.trim(),
        description: state.description?.trim(),
        channelImage: { id: state.channelImage?.id ?? undefined },
        workflows: (state.workflows ?? []).map((workflow_entry_id) => {
          return { id: workflow_entry_id }
        }),
        contacts: (state.contacts ?? []).map((contact_entry_id) => {
          return { id: contact_entry_id }
        })
      },
    }))[0];

  if (!entry) {
    // ---
    // TODO(@milo): redirect/throw if requested unknown profile
    return {};
    // throw new Error('Requested unknown profile:', entry_id)
    // ---
  }

  const state_contacts = useSelector((state) => state.contacts.active);
  const state_workflows = Object.values(useSelector((state) => state.workflows));

  const entry_assigned_contacts = entry.channel.contacts.map((lookup) => {
    // FIXME(@Milo): Expose this value within `state.contacts.channels`. 
    // This lookup dose not need to happen in a components lifecycle/render-call.
    const contact_state = state_contacts //
      .filter((state) => lookup.id == state.id)
      .map((state) => ({ ...state.toUser }))[0];

    return {
      id: contact_state.id,
      preferredName: contact_state.preferredName,
      alias: contact_state.alias,
      mail: contact_state.mail,
      userImage: { id: contact_state.id }
    }
  });

  const entry_workflows_forward = entry.channel.workflows.map((lookup) => {
    // FIXME(@Milo): Expose this value within `state.contacts.channels`. 
    // This lookup dose not need to happen in a components lifecycle/render-call.
    const workflow_state = state_workflows //
      .filter((state) => lookup.id == state.id)
      .map((state) => ({ ...state }))[0];

    return {
      user: entry.user,
      workflow: {
        id: workflow_state.id,
        title: workflow_state.title,
        description: i18n.t('showWorkflowScreen.numberOfSteps', { steps: workflow_state.steps.length }),
        workflowImage: {
          id: workflow_state.media[0]
        }
      },
    }
  });

  const template_aside = {
    aside: {
      title: entry.channel.name?.trim(),
      subtitle: entry.channel.description?.trim(),
      media: MediaSelector.imageSrc(entry.channel.channelImage.id, false),
      detail: [
        {
          role: 'list',
          name: i18n.t('channel.contacts', { num: entry.channel.contacts.length }),
          nested: entry_assigned_contacts.map((contacts_entry) => ({
            name: `${contacts_entry.preferredName?.trim()} (${contacts_entry.alias ?? contacts_entry.mail})`,
            // media: MediaSelector.imageSrc(contacts_entry.userImage.id, false),
          })),
          context: [{
            icon: { name: 'add' },
            callback: () => {
              dispatch(requestModal({
                type: 'channel:update-members',
                option: {
                  channel: { id: entry.channel.id },
                }
              }));
            }
          }]
        }
      ],
      context: [
        {
          name: i18n.t('channel.update'),
          action: 'primary',
          callback: () => {
            dispatch(requestModal({
              type: 'channel:update',
              option: { channel: { id: entry.channel.id } }
            }));
          }
        },
        {
          name: i18n.t('channel.deleteChannel'),
          action: 'negative',
          callback: () => {
            dispatch(requestModal({
              type: 'channel:remove',
              option: { channel: { id: entry.channel.id } }
            }));
          }
        }
      ]
    },
  };

  const template_prime = {
    prime: [
      {
        title: i18n.t('studio.channel.channelWorkflows'),
        nested: [
          {
            subtitle: i18n.t('studio.channel.sharedFromChannelToContactN', {
              channel: entry.channel.name,
              num: entry_workflows_forward.length
            }),
            entries: entry_workflows_forward,
            entry_header: {
              // FIXME(@Milo): That action is missing an ARIA label
              icon: { name: 'format-list-bulleted' },
              subicon: { name: 'edit' },
              callback: () => {
                dispatch(requestModal({
                  type: 'channel:update-workflows',
                  option: { channel: { id: entry.channel.id } }
                }));
              }
            }
          }
        ]
      }
    ]
  };

  return { template_aside, template_prime }
}

const resolve_contact_screen = ({ id }) => {
  const dispatch = useDispatch();

  const entry_id = id;
  const entry = useSelector((state) => state.contacts.active)
    .filter((state) => entry_id == state.toUser.id)
    .map((state) => ({
      contact: {
        id: state.id,
        contactAlias: state.contactAlias?.trim(),
        contactImage: { id: state.contactImage?.id }
      },
      user: {
        id: state.toUser.id,
        mail: state.toUser.mail?.trim(),
        preferredName: state.toUser.preferredName?.trim(),
        planningAllowed: state.planningAllowed ?? false,
        userImage: { id: state.toUser.id }
      },
    }))[0];

  if (!entry) {
    // ---
    // TODO(@milo): redirect/throw if requested unknown profile
    return {};
    // throw new Error('Requested unknown profile:', entry_id)
    // ---
  }

  const state_workflows = Object.values(useSelector((state) => state.workflows));

  const entry_workflows_receive = useSelector((state) => state.contacts.workflows)
    .filter((state) => state.contact == entry.contact.id)
    .map((lookup) => {
      // FIXME(@Milo): Expose this value within `state.contacts`.
      // This lookup dose not need to happen in a components lifecycle/render-call.
      const workflow_state = state_workflows //
        .filter((state) => lookup.id == state.id)
        .map((state) => ({ ...state }))[0];

      return {
        user: entry.user,
        workflow: {
          id: workflow_state.id,
          title: workflow_state.title,
          description: i18n.t('showWorkflowScreen.numberOfSteps', { steps: workflow_state.steps.length }),
          workflowImage: { id: workflow_state.media[0] }
        },
      }
    });

  const entry_workflows_forward = Object.entries(useSelector((state) => state.contacts.tasks2shares))
    .filter(([_workflow_key, state]) => state.contacts.includes(entry.contact.id))
    .map(([workflow_key, _state]) => {
      // FIXME(@Milo): Expose this value within `state.contacts`.
      // This lookup dose not need to happen in a components lifecycle/render-call.
      const workflow_state = state_workflows //
        .filter((state) => workflow_key == state.id)
        .map((state) => ({ ...state }))[0];

      return {
        user: entry.user,
        workflow: {
          id: workflow_state.id,
          title: workflow_state.title,
          description: i18n.t('showWorkflowScreen.numberOfSteps', { steps: workflow_state.steps.length }),
          workflowImage: {
            id: workflow_state.media[0]
          }
        },
      }
    });

  const entry_assigned_channels = useSelector((state) => state.contacts.channels)
    .filter((state) => state.contacts.includes(entry.contact.id))
    .map((state) => {
      return {
        channel: {
          id: state.id,
          name: state.name,
          description: i18n.t('studio.channel.membersN', { num: (state.contacts ?? []).length }),
          channelImage: { id: state.channelImage?.id }
        },
      }
    });

  const template_aside = {
    aside: {
      title: entry.user.preferredName,
      subtitle: entry?.contact?.contactAlias ?? entry.user.mail,
      media: entry?.contact?.contactImage?.id //
        ? MediaSelector.imageSrc(entry?.contact?.contactImage?.id, false)
        : MediaSelector.imageSrc(entry?.user?.userImage?.id, false),
      detail: [
        {
          role: 'checkbox',
          name: i18n.t('contact.planAllowed'),
          defaultValue: entry.user.planningAllowed,
        },
      ],
      context: [
        {
          name: i18n.t('contact.update'),
          action: 'primary',
          callback: () => {
            dispatch(requestModal({
              type: 'contact:update',
              option: { contact: { id: entry.contact.id }, toUser: { id: entry.user.id } }
            }));
          }
        },
        {
          name: i18n.t('contact.deleteContact'),
          action: 'negative',
          callback: () => {
            dispatch(requestModal({
              type: 'contact:remove',
              option: { contact: { id: entry.contact.id }, toUser: { id: entry.user.id } }
            }));
          }
        }
      ]
    },
  };

  const template_prime = {
    prime: [
      {
        title: i18n.t('studio.contact.sharedWorkflows'),
        nested: [
          {
            subtitle: i18n.t('studio.contact.sharedFromContactToMeN', {
              contact: entry.user.preferredName,
              num: entry_workflows_receive.length
            }),
            entries_max_rows: 0,
            entries: entry_workflows_receive
          },
          {
            subtitle: i18n.t('studio.contact.sharedFromMeToContactN', {
              contact: entry.user.preferredName,
              num: entry_workflows_forward.length
            }),
            entries_max_rows: 0,
            entries: entry_workflows_forward,
            entry_header: {
              // FIXME(@Milo): That action is missing an ARIA label
              icon: { name: 'share' },
              subicon: { name: 'edit' },
              callback: () => {
                dispatch(requestModal({
                  type: 'contact:update-workflows',
                  option: { contact: { id: entry.contact.id } }
                }));
              }
            }
          }
        ]
      },
      {
        title: i18n.t('channel.channels'),
        nested: [
          {
            subtitle: i18n.t('studio.contact.contactAddedTochannelByMeN', {
              contact: entry.user.preferredName,
              num: entry_assigned_channels.length
            }),
            entries_max_rows: 1,
            entries: entry_assigned_channels,
            entry_header: {
              // FIXME(@Milo): That action is missing an ARIA label
              icon: { name: 'campaign' },
              subicon: { name: 'edit' },
              callback: () => {
                dispatch(requestModal({
                  type: 'contact:update-channels',
                  option: { contact: { id: entry.contact.id } }
                }));
              }
            }
          }
        ]
      }
    ]
  };

  return { template_aside, template_prime }
}